'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ProductData } from '@/types/product';
import fixNewsContent from '@/lib/SVG_Render';
interface ProjectCardProps {
  project: ProductData;

}

// Memoize the component to prevent unnecessary re-renders when parent components update
export const ProjectCard: React.FC<ProjectCardProps> = React.memo(({ project }) => {
  const [isOpen, setIsOpen] = useState(false);
  const imageUrl = project.media?.[0]?.url || '/default.jpg'; 
  return (
    <Card className='border md:border-ring p-4'>
      <CardContent className={`px-0  w-full flex ${isOpen ? "flex-col items-center md:items-start" : "flex-row"} gap-3 md:gap-6 lg:gap-10 `}>
        <div className=''>
          <div className='relative h-32 md:h-44 w-32 md:w-44 flex-shrink-0'> 
            <Image
              src={imageUrl}
              alt={project.title || "Project image"} 
              fill

              sizes="(max-width: 768px) 128px, 176px"
              loading="lazy"    
              className="object-cover rounded-md" 
            />
          </div>
        </div>
        <div className='flex flex-col h-full w-full space-y-4 md:space-y-6'>
          <h3 className={`font-semibold text-sm md:text-base ${isOpen ? "line-clamp-none" : "line-clamp-2 md:line-clamp-none"} leading-relaxed`}>
            {project.title}
          </h3>
          {/* Conditionally render dangerouslySetInnerHTML only when content exists or is open */}
          {project.content && (
            <div
              className={`prose text-xs sm:text-sm text-muted-foreground leading-relaxed ${isOpen ? "line-clamp-none" : "line-clamp-2 md:line-clamp-3"} `}
              dangerouslySetInnerHTML={{ __html: fixNewsContent(project.content) }}
            />
          )}
          <Button
            onClick={() => setIsOpen(!isOpen)}
            size="sm"
            className="text-white  bg-primary hover:bg-prime-hover cursor-pointer rounded-full w-fit ">
            {isOpen ? "Read Less" : "Read More"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
});